<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-help</v-icon>
        <v-toolbar-title>Block Group Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.accmType }}</td>
                  <td class="text-xs-left">{{ row.item.blkGrp }}</td>
                  <td class="text-xs-left">{{ row.item.blkGrpDescS }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  props: {
    accmType: String
  },
  data() {
    return {
      headers: [
        { text: 'Accumulation Type', value: 'accmType' },
        { text: 'Block Group', value: 'blkGrp' },
        { text: 'Short Description', value: 'blkGrpDescS' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    accmType: function (value) {
      this.doInit()
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    doInit() {
      if (this.accmType) {
        const apiURI = this.menu.getBlkGrpListByAccmType
        if (apiURI) {
          this.loading = true
          const expand = { accmType: this.accmType }
          this.$http
            .get(expandURI(apiURI, expand))
            .then((result) => {
              this.items = []
              const { data } = result.data
              if (data) {
                data.map((blkGrpList) => {
                  const convertList = {
                    accmType: blkGrpList.accmType,
                    blkGrp: blkGrpList.blkGrp,
                    blkGrpDescS: blkGrpList.blkGrpDescS
                  }
                  this.items.push(convertList)
                })
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              const { data } = err.response
              if (data) {
                this.message(data)
                this.fieldMessage(data)
              }
            })
        }
      } else {
        this.items = []
      }
    },
    doSelect(data) {
      const blkGrp = data.blkGrp
      this.$emit('doAssign', blkGrp)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
